module.exports = __webpack_public_path__ + "static/gravity-ff1a23a1a86b8cebe3af1f9efd059164.svg";